import React from 'react'
import ColumnLayout from '@cloudscape-design/components-themed/column-layout'

// https://cloudscape.design/components/column-layout
export function RadColumnLayout ({ ...rest }) {
  return (
    <ColumnLayout {...rest} />
  )
}
